<div class="searchView verticalCenterView">
    <h1 class="searchView__title" *ngIf="getRouterUrl() != '/'">Search Ads</h1>
    <form class="searchView__form" [formGroup]="advSearchForm">
        
        <mat-radio-group color="primary" class="searchView__radioGroup" aria-label="Select an option" formControlName="casualDating">
            <mat-radio-button [value]="false">Long Term</mat-radio-button>
            <mat-radio-button [value]="true">Casual Dating</mat-radio-button>
        </mat-radio-group>

        <mat-form-field class="searchView__relationship">
            <mat-select placeholder="Relationship" name="relationship" formControlName="relationShips" >
                <mat-option (click)="advSearchForm.controls.relationShips.reset()"></mat-option>
                <mat-option *ngFor="let cat of categories | async" [value]="cat.advertisementCategoryId">
                    {{cat.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="searchView__fieldBox">
            <mat-form-field [hidden]="SearchType == SearchTypes.Zip"  class="searchView__state without-pb-field">
                <mat-select #regionSelect disableOptionCentering="true" placeholder="State" name="state" formControlName="region" (selectionChange)="setSelectedRegion($event.value)" (openedChange)="selectOpenChange($event, this.regionSelect)">
                    <mat-select-trigger>
                        {{ this.getRegionData(this.advSearchForm.controls["region"].value)?.shortName }}
                    </mat-select-trigger>
                    <mat-option> 
                    <ngx-mat-select-search  
                                            [placeholderLabel]="'State'"
                                            [noEntriesFoundLabel]="'No matching found'"
                                            [formControl]="regionFilter"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let r of filteredRegions"
                                [value]="r.regionId">
                        {{ r.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
    
            <mat-form-field [hidden]="SearchType == SearchTypes.Zip"  class="searchView__city without-pb-field">
                <mat-select #citySelect placeholder="City" name="city" formControlName="subregion" (openedChange)="openedChange($event); selectOpenChange($event, this.citySelect)" (infiniteScroll)="callGetNextBatch()" [complete]="offset === filteredSubregion.length" msInfiniteScroll>
                    <mat-option>
                        <ngx-mat-select-search #citySearchSelect
                                               [placeholderLabel]="'ex. Newport'"
                                               [noEntriesFoundLabel]="'No matching found'"
                                               [formControl]="subregionFilter"
                                               [disableScrollToActiveOnOptionsChanged]="true"
                                               [clearSearchInput]="false"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let option of subRegionsOptions$ | async" [value]="option.subRegionId">
                        {{option.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field [hidden]="SearchType == SearchTypes.City"  class="searchView__zip without-pb-field">
                <mat-label>Zip</mat-label>
                <input matInput type="text" formControlName="zipCode">
                <button mat-button *ngIf="zipCode" matSuffix mat-icon-button aria-label="Clear" (click)="resetZip()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field [hidden]="SearchType == SearchTypes.City"  class="searchView__miles without-pb-field">
                <mat-label>Miles</mat-label>
                <mat-select #milesSelect placeholder="Miles" name="miles" (openedChange)="selectOpenChange($event, this.milesSelect)">
                    <mat-option *ngFor="let mile of miles" [value]="mile">
                        {{mile.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-checkbox class="searchView__checkPicture">With pics</mat-checkbox>
        <div class="searchView__zipSwitch"><button mat-button color="primary" href="#" (click)="changeSearchType($event)">Switch {{this.SearchType == SearchTypes.Zip ? 'City' : 'Zip'}}</button></div>

        <mat-form-field class="searchView__keywords without-pb-field">
            <mat-label>Keywords</mat-label>
            <input matInput type="text" formControlName="keywords">
            <button mat-button *ngIf="keywords.value" matSuffix mat-icon-button aria-label="Clear" (click)="resetKeywords()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        
        <div class="searchView__btSearch">
            <!-- [disabled]="!this.regions || this.regions.length == 0" -->
            <button mat-raised-button color="primary" [disabled]="loading || !this.regions || this.regions.length == 0" (click)="onSubmit(true,'urlsearch')">Search</button>
        </div>
        
    </form>
</div>